module.exports = __webpack_public_path__ + "static/media/Strawberry-Colada-Tower-768x690.0af80f41.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/page/cta/Strawberry-Colada-Tower-768x690.png
// module id = 108
// module chunks = 0